module.exports = __webpack_public_path__ + "img/unordered-list.1540c44e.svg";